<template>
  <div style="width: 100vw;height: 100vh;">
    <img src="@/assets/SatelliteActivityShoot/background.png" style="position: fixed;width: 100vw;height: 100vh;"/>
    <div class="blur-container"></div>
    <TopShareBar v-if="share"/>
    <div
        style="position: relative;display: flex;padding-top: 95px;padding-left: 21px;padding-right: 11px;justify-content: space-between;">
      <div style="color: white;font-size: 22px;font-weight: 400;padding-top: 15px;font-family: YouSheBiaoTiHei">
        <div>写下帮拍心愿</div>
        <div>太空专属摄影师为你定格瞬间</div>
      </div>
      <div @click="intoSatelliteShootRule" class="mid-center"
           style="width: 38px;height: 38px;background-color: rgba(255, 255, 255, 0.25);border-radius: 4px;color: white;font-size: 12px;font-family:HarmonyOSSansSCRegular;">
        规则
      </div>
    </div>
    <!--    推荐卡片区域-->
    <div style="display: flex;overflow-x: auto;width: 100vw;white-space: nowrap;margin-top: 29px;">
      <div v-for="(item, index) in recommendShootList" :key="index"
           @click="intoShootDetail(item.satelliteShootId)"
           :style="{marginRight: index === recommendShootList.length - 1 ? '20px' : '0px', background: `url(${item.finalPicture}) center/cover no-repeat`}"
           class="recommend-card-area">
        <div style="display: flex;align-items: center;margin-left: 7px;margin-top: 14px;position: relative;">
          <div style="color: white;font-size: 16px;" class="iconfontFamily">&#xe7bb;</div>
          <div style="color: white;margin-left: 7px;font-size: 16px;width: 180px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;;;font-family:HarmonyOSSansSCRegular"
               class="iconfontFamily">{{ item.poi }}
          </div>
        </div>
        <!-- 介绍部分 -->
        <div
            class="recommend-card-introduction">
          <div style="padding: 6px 9px;">
            <div style="display: flex;align-items: center">
              <div style="width: 22px;height: 22px;border-radius: 50%;"
                   :style="{background: `url(${item.userPicture}) center/cover no-repeat`}"></div>
              <div style="font-family:HarmonyOSSansSCRegular;font-size: 14px;color: white;margin-left: 8px">{{ item.userName }}</div>
            </div>
            <div class="card-introduction">
              {{ item.userText }}
            </div>
          </div>
          <div style="position: absolute;left: -1px;top: 33px;width: 1px;height: 6px;background-color: white"></div>
          <div style="position: absolute;right: -1px;top: 33px;width: 1px;height: 6px;background-color: white"></div>
        </div>
      </div>
    </div>
    <!--    参与方式区域-->
    <div
        style="position: relative;color: rgba(166, 166, 166, 1);font-size: 14px;font-family:HarmonyOSSansSCRegular;margin: 23px 15px 0 21px;line-height: 24px;">
      <div>参与方式：</div>
      <div>1.选择想帮拍的区域，并写下寄语，有一定概率可获得卫星帮拍资格。</div>
      <div>2.由于受天气与卫星轨道影响，卫星帮拍存在一定失败概率，帮拍进度达到100%时将为您执行帮拍任务。</div>
      <div>3.帮拍成功后，我们将在1-2个工作日内为您返回拍摄结果。</div>
    </div>
    <div style="display: flex;align-items: center;position: relative;margin-top: 12px;padding-left: 28px;padding-right: 28px;justify-content: space-between">
      <div @click="intoMySatelliteShoot" style="width: 107px;height: 50px;border-radius: 13px;border: 1px solid rgba(255, 255, 255, 0.1);background-color: rgba(42, 130, 228, 0.28);color: white" class="mid-center">我的帮拍</div>
      <div @click="clickButton" style="width: 210px;height: 50px;border-radius: 13px;background: linear-gradient(223.26deg, rgba(71, 140, 255, 1) 0%, rgba(75, 191, 254, 1) 100%);color: white;margin-left: 17px;" class="mid-center">
        {{ share ? '+ 发起帮拍' : canCreateShoot ? '+ 发起帮拍' : '查看帮拍进度'}}
<!--        {{ canCreateShoot}}-->
      </div>
    </div>
  </div>
</template>

<script>
import TopShareBar from "@/components/TopShareBar.vue";

export default {
  name: 'SatelliteActivityShoot',
  components: {TopShareBar},
  data() {
    return {
      share: false,
      recommendShootList: [],
      canClickButton: false,
      canCreateShoot: true,
    }
  },
  methods: {
    getRecommendShootList() {
      this.$http.get('/earthApi/satellite-shoot-info/getLatestSatelliteShootInfoList?num=3').then((resp) => {
        resp = resp.data
        if (resp.status === 200) {
          this.recommendShootList = resp.data
        }
      })
    },
    intoShootDetail(infoId) {
      if (this.share) {
        // 进入h5页
        this.$router.push({
          path: '/SatelliteShootDetail',
          query: {
            share: '1',
            infoId: infoId
          }
        })
      } else {
        if (window['flutter_getSatelliteShootDetail']) {
          window['flutter_getSatelliteShootDetail'].postMessage(infoId)
        }
      }
    },
    // 我的帮拍
    intoMySatelliteShoot() {
      if (this.share) {
        // 打开app对应页
        this.openApp()
      } else {
        if (window['flutter_intoMySatelliteShoot']) {
          window['flutter_intoMySatelliteShoot'].postMessage('')
        }
      }
    },

    setButtonStatus(status) {
      this.canClickButton = true
      this.canCreateShoot = status
    },

    // 发起帮拍 或 进入帮拍进度
    clickButton() {
      if (this.share) {
        // 打开app对应页
        this.openApp()
      } else if (!this.canClickButton) {
        return
      } else {
        if (this.canCreateShoot && window['flutter_createSatelliteShoot']) {
          window['flutter_createSatelliteShoot'].postMessage('')
        } else if (!this.canCreateShoot && window['flutter_intoSatelliteShootProgress']) {
          window['flutter_intoSatelliteShootProgress'].postMessage('')
        }
      }
    },
    intoSatelliteShootRule() {
      if (this.share) {
        this.$router.push({path: '/SatelliteShootRule',query: {share: '1'}})
      } else {
        if (window['flutter_intoSatelliteShootRule']) {
          window['flutter_intoSatelliteShootRule'].postMessage('')
        }
      }
    },

    // 搬运的方法
    schemeUrl(){
      return 'charmingearth://earth.jl1.cn?infoId=undefined&type=1502'
    },
    openApp() {
      window.location.href = '/OpenApp?infoId=&type=1502'
      // let u = window.navigator.userAgent;
      // let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1; //android终端或者uc浏览器
      // let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
      // if(isAndroid){
      //   this.android();
      // }
      // if(isiOS){
      //   this.ios();
      // }
    },
    android(){
      let _clickTime = new Date().getTime();
      window.location.href = this.schemeUrl()
      //启动间隔20ms运⾏的定时器，并检测累计消耗时间是否超过3000ms，超过则结束
      let _count = 0, intHandle;
      let _this = this;
      intHandle = setInterval(function(){
        _count++;
        let elsTime = new Date().getTime() - _clickTime;
        if (_count>=100 || elsTime > 3000 ) {
          console.log(_count)
          console.log(elsTime)
          clearInterval(intHandle);
          //检查app是否打开
          if ( document.hidden || document.webkitHidden) {
            // 打开了
            window.close();
          } else {
            // 没打开
            if(_this.sourceThis != ""){
              window.location.href = "/appdownload?source="+_this.sourceThis;//下载链接
            }
            else{
              window.location.href = "/appdownload";//下载链接
            }
          }
        }
      }, 20);
    },
    ios(){
      let _clickTime = +(new Date());
      let ifr = document.createElement("iframe");
      ifr.src = this.schemeUrl()
      ifr.style.display = "none";
      document.body.appendChild(ifr);
      //启动间隔20ms运⾏的定时器，并检测累计消耗时间是否超过3000ms，超过则结束
      let _count = 0, intHandle;
      intHandle = setInterval(function(){
        _count++;
        let elsTime =  +(new Date()) - _clickTime;
        console.log(_count,elsTime,+(new Date()),_clickTime)
        if (_count>=100 || elsTime > 3000 ) {
          clearInterval(intHandle);
          document.body.removeChild(ifr);
          //检查app是否打开
          if ( document.hidden || document.webkitHidden) {
            // 打开了
            window.close();
          } else {
            // 没打开
            // alert('没打开')
            window.location.href = "https://apps.apple.com/cn/app/id1628699115";//下载链接
          }
        }
      },20);
    },
    addViewCount() {
      this.$http.get('/earthApi/user-picture-shopping-cart/readActivity?activityType=1502').then((resp) => {
        resp = resp.data
        if (resp.status === 200) {
          //
        }
      })
    }
  },
  mounted() {
    // window.satelliteActivityH5One = this;
    // this.cardActivityId = this.$route.query.infoId;
    window.satelliteActivityShoot = this
    this.share = this.$route.query.share === '1';
    document.title = '卫星帮拍'
    this.getRecommendShootList()
    if (window['flutter_satelliteActivityShootMounted']) {
      window['flutter_satelliteActivityShootMounted'].postMessage('')
    }
    this.addViewCount()
  }
}
</script>

<style scoped>
.mid-center {
  display: flex;
  align-items: center;
  justify-content: center;
}

.card-introduction {
  /* 重置所有样式，从头开始 */
  all: initial;

  /* 重新设置基本样式 */
  color: white;
  font-size: 13px;
  font-family: HarmonyOSSansSCRegular, sans-serif; /* 先用系统字体 */
  display: block;
  width: 100%;
  margin-top: 5px;
  /* 多行省略 */
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  text-overflow: ellipsis;
}

.recommend-card-area {
  width: 224px;
  height: 344px;
  flex: 0 0 auto;
  border-radius: 8px;
  margin-left: 20px;
  position: relative;
}

.recommend-card-introduction {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  border-radius: 8px;
  width: 222px;
  height: 72px;
  backdrop-filter: blur(20px);
  background-color: rgba(3, 5, 15, 0.6);
  border: 1px solid rgba(255, 255, 255, 0.4)
}

.blur-container {
  width: 100vw;
  height: 100vh;
  position: fixed;
  backdrop-filter: blur(13px);
  background-color: rgba(0, 0, 0, 0.2)
}
</style>